export const COLOR_SWATCH: Record<string, string> = {
  Natural: "#E7CAAC",
  Cerulean: "#00B7E8",
  Silver: "#9C9AA4",
  Snow: "#FFFFFF",
  Sunshine: "#FFBE08",
};

export const COLOR_OPTIONS = Object.keys(COLOR_SWATCH);

export const DEFAULT_COLOR_STORK = "Cerulean";
export const DEFAULT_COLOR_FALCON = "Sunshine";
export const DEFAULT_COLOR_SPARROW = "Natural";
